module.exports = __webpack_public_path__ + "static/img/3_2.46ce66e1.jpg";